module.exports = __webpack_public_path__ + "img/hic-colorectal-cancer-female.9a5fa3e2.png";